//if all the links are flagged as opened - then allow the checkbox to be selected
const becomingRegisteredForm = document.querySelector('form[name="becoming-registered"]');
if (becomingRegisteredForm !== null) {
    Array.from(becomingRegisteredForm.querySelectorAll('a[data-opened]')).map((link) => {
        link.addEventListener('click', () => {
            link.setAttribute('data-opened', -1);
            icon = link.closest('p').querySelector('i');
            icon.classList.remove('fa-circle');
            icon.classList.add('fa-check');
            if (becomingRegisteredForm.querySelectorAll('a[data-opened]').length === becomingRegisteredForm.querySelectorAll('a[data-opened="-1"]').length) {
                
                //
                const becomingRegisteredCheckbox = becomingRegisteredForm.querySelector('input[type="checkbox"]')
                becomingRegisteredCheckbox.disabled = false;
                becomingRegisteredCheckbox.checked = true;

                //
                const submitButton = becomingRegisteredForm.querySelector('[name="submit-termsandconditions"]');
                submitButton.disabled = false;
                submitButton.classList.remove('btn-disabled');

            }
        })
    });
}